import { defineNuxtPlugin } from '#app/nuxt'
import { LazyTemplateArticleAreaMeta, LazyTemplateArticleArea, LazyTemplateArticleItem, LazyTemplateAskQuestionMeta, LazyTemplateAskQuestion, LazyTemplateAuthorAreaMeta, LazyTemplateAuthorArea, LazyTemplateAuthorItemMeta, LazyTemplateAuthorItem, LazyTemplateCheckoutMeta, LazyTemplateCheckout, LazyTemplateCheckoutResult, LazyTemplateCompetitionItem, LazyTemplateConfirmMat, LazyTemplateContact, LazyTemplateContentItemMeta, LazyTemplateContentItem, LazyTemplateContributeMeta, LazyTemplateContribute, LazyTemplateDiscoverAreaMeta, LazyTemplateDiscoverArea, LazyTemplateDiscoverThemeMeta, LazyTemplateDiscoverTheme, LazyTemplateDiscoverTopicsMeta, LazyTemplateDiscoverTopics, LazyTemplateDynamicContentItem, LazyTemplateEventAreaMeta, LazyTemplateEventArea, LazyTemplateEventItem, LazyTemplateGetPublishedMeta, LazyTemplateGetPublished, LazyTemplateHome, LazyTemplateJoinAsIndividual, LazyTemplateJoinAsSchool, LazyTemplateLinkSchoolsMeta, LazyTemplateLinkSchools, LazyTemplateLogin, LazyTemplateMemberItemMeta, LazyTemplateMemberItem, LazyTemplateMyAccountMeta, LazyTemplateMyAccount, LazyTemplateMyAccountContributionsMeta, LazyTemplateMyAccountContributions, LazyTemplateMyAccountDetailsMeta, LazyTemplateMyAccountDetails, LazyTemplateMyAccountNetworksMeta, LazyTemplateMyAccountNetworks, LazyTemplateMyAccountPreferencesMeta, LazyTemplateMyAccountPreferences, LazyTemplateMyAccountSchoolsMeta, LazyTemplateMyAccountSchools, LazyTemplateMyAccountSettingsMeta, LazyTemplateMyAccountSettings, LazyTemplateMyNeaMeta, LazyTemplateMyNea, LazyTemplateOnDemandEventArea, LazyTemplateOnDemandEventItem, LazyTemplatePartnerAreaMeta, LazyTemplatePartnerArea, LazyTemplatePartnerIntroduction, LazyTemplatePartnerItem, LazyTemplateQuestionAreaMeta, LazyTemplateQuestionArea, LazyTemplateQuestionItemMeta, LazyTemplateQuestionItem, LazyTemplateRecommendedAreaMeta, LazyTemplateRecommendedArea, LazyTemplateRegisterMeta, LazyTemplateRegister, LazyTemplateResetPassword, LazyTemplateSchoolAreaMeta, LazyTemplateSchoolArea, LazyTemplateSchoolItemMeta, LazyTemplateSchoolItem, LazyTemplateSelectPreferencesMeta, LazyTemplateSelectPreferences, LazyTemplateSelectSubscriptionMeta, LazyTemplateSelectSubscription, LazyBlockElementHeadline, LazyBlockElementMedia, LazyBlockElementQuote, LazyBlockElementRte, LazyBlockGridLayout, LazyBlockGridLayout12Columns, LazyBlockGridLayout1Column, LazyBlockGridLayout21Columns, LazyBlockGridLayout2Columns, LazyBlockGridLayout3Columns, LazyBlockNestedGrid, LazyContentGridControlsControlApolloGridAccordionEditor, LazyContentGridControlsControlApolloGridCarouselEditor, LazyContentGridControlsControlApolloGridCopyEditor, LazyContentGridControlsControlApolloGridHeadingEditor, LazyContentGridControlsControlApolloGridQuoteEditor, LazyContentGridControlsControlApolloGridRichTextEditor, LazyContentGridControlsControlHeadline, LazyContentGridControlsControlMedia, LazyContentGridControlsControlQuote, LazyContentGridControlsControlRte } from '#components'
const lazyGlobalComponents = [
  ["TemplateArticleAreaMeta", LazyTemplateArticleAreaMeta],
["TemplateArticleArea", LazyTemplateArticleArea],
["TemplateArticleItem", LazyTemplateArticleItem],
["TemplateAskQuestionMeta", LazyTemplateAskQuestionMeta],
["TemplateAskQuestion", LazyTemplateAskQuestion],
["TemplateAuthorAreaMeta", LazyTemplateAuthorAreaMeta],
["TemplateAuthorArea", LazyTemplateAuthorArea],
["TemplateAuthorItemMeta", LazyTemplateAuthorItemMeta],
["TemplateAuthorItem", LazyTemplateAuthorItem],
["TemplateCheckoutMeta", LazyTemplateCheckoutMeta],
["TemplateCheckout", LazyTemplateCheckout],
["TemplateCheckoutResult", LazyTemplateCheckoutResult],
["TemplateCompetitionItem", LazyTemplateCompetitionItem],
["TemplateConfirmMat", LazyTemplateConfirmMat],
["TemplateContact", LazyTemplateContact],
["TemplateContentItemMeta", LazyTemplateContentItemMeta],
["TemplateContentItem", LazyTemplateContentItem],
["TemplateContributeMeta", LazyTemplateContributeMeta],
["TemplateContribute", LazyTemplateContribute],
["TemplateDiscoverAreaMeta", LazyTemplateDiscoverAreaMeta],
["TemplateDiscoverArea", LazyTemplateDiscoverArea],
["TemplateDiscoverThemeMeta", LazyTemplateDiscoverThemeMeta],
["TemplateDiscoverTheme", LazyTemplateDiscoverTheme],
["TemplateDiscoverTopicsMeta", LazyTemplateDiscoverTopicsMeta],
["TemplateDiscoverTopics", LazyTemplateDiscoverTopics],
["TemplateDynamicContentItem", LazyTemplateDynamicContentItem],
["TemplateEventAreaMeta", LazyTemplateEventAreaMeta],
["TemplateEventArea", LazyTemplateEventArea],
["TemplateEventItem", LazyTemplateEventItem],
["TemplateGetPublishedMeta", LazyTemplateGetPublishedMeta],
["TemplateGetPublished", LazyTemplateGetPublished],
["TemplateHome", LazyTemplateHome],
["TemplateJoinAsIndividual", LazyTemplateJoinAsIndividual],
["TemplateJoinAsSchool", LazyTemplateJoinAsSchool],
["TemplateLinkSchoolsMeta", LazyTemplateLinkSchoolsMeta],
["TemplateLinkSchools", LazyTemplateLinkSchools],
["TemplateLogin", LazyTemplateLogin],
["TemplateMemberItemMeta", LazyTemplateMemberItemMeta],
["TemplateMemberItem", LazyTemplateMemberItem],
["TemplateMyAccountMeta", LazyTemplateMyAccountMeta],
["TemplateMyAccount", LazyTemplateMyAccount],
["TemplateMyAccountContributionsMeta", LazyTemplateMyAccountContributionsMeta],
["TemplateMyAccountContributions", LazyTemplateMyAccountContributions],
["TemplateMyAccountDetailsMeta", LazyTemplateMyAccountDetailsMeta],
["TemplateMyAccountDetails", LazyTemplateMyAccountDetails],
["TemplateMyAccountNetworksMeta", LazyTemplateMyAccountNetworksMeta],
["TemplateMyAccountNetworks", LazyTemplateMyAccountNetworks],
["TemplateMyAccountPreferencesMeta", LazyTemplateMyAccountPreferencesMeta],
["TemplateMyAccountPreferences", LazyTemplateMyAccountPreferences],
["TemplateMyAccountSchoolsMeta", LazyTemplateMyAccountSchoolsMeta],
["TemplateMyAccountSchools", LazyTemplateMyAccountSchools],
["TemplateMyAccountSettingsMeta", LazyTemplateMyAccountSettingsMeta],
["TemplateMyAccountSettings", LazyTemplateMyAccountSettings],
["TemplateMyNeaMeta", LazyTemplateMyNeaMeta],
["TemplateMyNea", LazyTemplateMyNea],
["TemplateOnDemandEventArea", LazyTemplateOnDemandEventArea],
["TemplateOnDemandEventItem", LazyTemplateOnDemandEventItem],
["TemplatePartnerAreaMeta", LazyTemplatePartnerAreaMeta],
["TemplatePartnerArea", LazyTemplatePartnerArea],
["TemplatePartnerIntroduction", LazyTemplatePartnerIntroduction],
["TemplatePartnerItem", LazyTemplatePartnerItem],
["TemplateQuestionAreaMeta", LazyTemplateQuestionAreaMeta],
["TemplateQuestionArea", LazyTemplateQuestionArea],
["TemplateQuestionItemMeta", LazyTemplateQuestionItemMeta],
["TemplateQuestionItem", LazyTemplateQuestionItem],
["TemplateRecommendedAreaMeta", LazyTemplateRecommendedAreaMeta],
["TemplateRecommendedArea", LazyTemplateRecommendedArea],
["TemplateRegisterMeta", LazyTemplateRegisterMeta],
["TemplateRegister", LazyTemplateRegister],
["TemplateResetPassword", LazyTemplateResetPassword],
["TemplateSchoolAreaMeta", LazyTemplateSchoolAreaMeta],
["TemplateSchoolArea", LazyTemplateSchoolArea],
["TemplateSchoolItemMeta", LazyTemplateSchoolItemMeta],
["TemplateSchoolItem", LazyTemplateSchoolItem],
["TemplateSelectPreferencesMeta", LazyTemplateSelectPreferencesMeta],
["TemplateSelectPreferences", LazyTemplateSelectPreferences],
["TemplateSelectSubscriptionMeta", LazyTemplateSelectSubscriptionMeta],
["TemplateSelectSubscription", LazyTemplateSelectSubscription],
["BlockElementHeadline", LazyBlockElementHeadline],
["BlockElementMedia", LazyBlockElementMedia],
["BlockElementQuote", LazyBlockElementQuote],
["BlockElementRte", LazyBlockElementRte],
["BlockGridLayout", LazyBlockGridLayout],
["BlockGridLayout12Columns", LazyBlockGridLayout12Columns],
["BlockGridLayout1Column", LazyBlockGridLayout1Column],
["BlockGridLayout21Columns", LazyBlockGridLayout21Columns],
["BlockGridLayout2Columns", LazyBlockGridLayout2Columns],
["BlockGridLayout3Columns", LazyBlockGridLayout3Columns],
["BlockNestedGrid", LazyBlockNestedGrid],
["ContentGridControlsControlApolloGridAccordionEditor", LazyContentGridControlsControlApolloGridAccordionEditor],
["ContentGridControlsControlApolloGridCarouselEditor", LazyContentGridControlsControlApolloGridCarouselEditor],
["ContentGridControlsControlApolloGridCopyEditor", LazyContentGridControlsControlApolloGridCopyEditor],
["ContentGridControlsControlApolloGridHeadingEditor", LazyContentGridControlsControlApolloGridHeadingEditor],
["ContentGridControlsControlApolloGridQuoteEditor", LazyContentGridControlsControlApolloGridQuoteEditor],
["ContentGridControlsControlApolloGridRichTextEditor", LazyContentGridControlsControlApolloGridRichTextEditor],
["ContentGridControlsControlHeadline", LazyContentGridControlsControlHeadline],
["ContentGridControlsControlMedia", LazyContentGridControlsControlMedia],
["ContentGridControlsControlQuote", LazyContentGridControlsControlQuote],
["ContentGridControlsControlRte", LazyContentGridControlsControlRte],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
